/* Eva Jurado */
(function(){
  'use strict';
  var nav = document.getElementById('nav');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tareas = [];
  var pendiente = false;
  function correr(){ for (var i = 0; i < tareas.length; i++) { try { tareas[i](); } catch(e){} } }
  window.addEventListener('scroll', function(){
    if (!pendiente) { pendiente = true; requestAnimationFrame(function(){ pendiente = false; correr(); }); }
  }, {passive:true});
  window.addEventListener('resize', correr);

  /* ---- el descenso ---- */
  var stage = document.getElementById('stage'),
      sec   = document.getElementById('descenso'),
      prof  = document.getElementById('prof');
  if (stage && sec) {
    tareas.push(function(){
      var h = sec.offsetHeight - window.innerHeight;
      var p = Math.min(1, Math.max(0, -sec.getBoundingClientRect().top / (h || 1)));
      var ease = p < .5 ? 2*p*p : 1 - Math.pow(-2*p+2, 2)/2;
      stage.style.setProperty('--os', (1.22 - .22*ease).toFixed(4));
      stage.style.setProperty('--oo', Math.min(1, p*2.1).toFixed(3));
      stage.style.setProperty('--ov', (.92 - .74*Math.min(1, p*1.5)).toFixed(3));
      stage.style.setProperty('--ry', (p*-140).toFixed(1)+'px');
      stage.style.setProperty('--to', (1 - Math.max(0, (p-.62)/.28)).toFixed(3));
      stage.style.setProperty('--tl', (.30 - .13*ease).toFixed(3)+'em');
      stage.style.setProperty('--lz', Math.max(0, (p-.86)/.14).toFixed(3));
      stage.style.setProperty('--dp', (p*100).toFixed(1)+'%');
      if (prof) prof.textContent = Math.round(p*40)+' m';
      if (nav) nav.classList.toggle('on', p > .9);
    });
  }

  /* ---- revelado: se oculta solo lo que está fuera de pantalla ---- */
  if (!reduce) {
    var todos = Array.prototype.slice.call(document.querySelectorAll('.rev, .pieza'));
    var alto = window.innerHeight;
    var espera = [];
    todos.forEach(function(el){
      if (el.getBoundingClientRect().top > alto * 0.9) { el.classList.add('esperando'); espera.push(el); }
    });
    if (espera.length) {
      var mirar = function(){
        var a = window.innerHeight;
        for (var i = espera.length - 1; i >= 0; i--) {
          if (espera[i].getBoundingClientRect().top < a * 0.9) { espera[i].classList.remove('esperando'); espera.splice(i, 1); }
        }
      };
      tareas.push(mirar);
      setTimeout(function(){
        document.querySelectorAll('.esperando').forEach(function(el){ el.classList.remove('esperando'); });
        espera.length = 0;
      }, 6000);
    }
  }

  /* ---- vídeo del taller ---- */
  var vid = document.getElementById('vid'), play = document.getElementById('play');
  if (vid && play) {
    /* El botón se esconde cuando el vídeo empieza DE VERDAD. Antes dependía de que
       resolviera la primera promesa de play(); si esa se rechazaba y luego lo
       arrancaba el observer, el botón se quedaba encima del vídeo en marcha. */
    vid.addEventListener('playing', function(){ play.hidden = true; });
    vid.play().then(function(){ play.hidden = true; }).catch(function(){});
    /* Si el archivo no llega a decodificarse (p. ej. servido como application/mp4),
       quitamos el botón y se queda el póster, en vez de un botón muerto. */
    setTimeout(function(){ if (vid.readyState === 0) { play.hidden = true; } }, 9000);
    play.addEventListener('click', function(){
      vid.play().then(function(){ play.hidden = true; }).catch(function(){});
    /* Si el archivo no llega a decodificarse (p. ej. servido como application/mp4),
       quitamos el botón y se queda el póster, en vez de un botón muerto. */
    setTimeout(function(){ if (vid.readyState === 0) { play.hidden = true; } }, 9000);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es){ es.forEach(function(e){
        if (e.isIntersecting) { vid.play().catch(function(){}); } else { vid.pause(); }
      }); }, { threshold: .2 }).observe(vid.closest('#video') || vid);
    }
  }

  /* ---- filtro de la rejilla ---- */
  var filtro = document.querySelector('.filtro');
  if (filtro) {
    filtro.addEventListener('click', function(ev){
      var b = ev.target.closest('button'); if (!b) return;
      var f = b.dataset.filtro;
      filtro.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      document.querySelectorAll('.pieza').forEach(function(p){
        p.hidden = !(f === 'todas' || p.dataset.estado === f);
      });
      document.querySelectorAll('.colec').forEach(function(c){
        c.hidden = c.querySelectorAll('.pieza:not([hidden])').length === 0;
      });
      var vacio = document.getElementById('sin-obra');
      if (vacio) vacio.hidden = document.querySelectorAll('.pieza:not([hidden])').length > 0;
    });
  }

  /* ---- obra preseleccionada en el formulario ---- */
  var sel = document.getElementById('campo-obra');
  if (sel) {
    var q = new URLSearchParams(location.search).get('obra');
    if (q) Array.prototype.forEach.call(sel.options, function(o){ if (o.value === q) o.selected = true; });
  }

  /* ---- la barra se invierte sobre fondo oscuro ----
     Solo es presentación: si esto no corre, la barra se queda clara y se lee igual. */
  var oscuras = Array.prototype.slice.call(document.querySelectorAll('#descenso, .cita, #video, .oscuro'));
  if (nav && oscuras.length) {
    tareas.push(function(){
      var banda = nav.offsetHeight ? nav.offsetHeight * 0.6 : 44;
      var sobre = false;
      for (var i = 0; i < oscuras.length; i++) {
        var r = oscuras[i].getBoundingClientRect();
        if (r.top <= banda && r.bottom > banda) { sobre = true; break; }
      }
      nav.classList.toggle('inv', sobre);
    });
  }

  /* ---- el desplegable del menú, para pantallas táctiles ----
     En ratón y teclado ya funciona solo con CSS (:hover y :focus-within). */
  var subBoton = document.querySelector('#nav .sub > button');
  if (subBoton) {
    subBoton.addEventListener('click', function(){
      var abierto = subBoton.getAttribute('aria-expanded') === 'true';
      subBoton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
    });
    document.addEventListener('click', function(ev){
      if (!ev.target.closest('#nav .sub')) subBoton.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('keydown', function(ev){
      if (ev.key === 'Escape') subBoton.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---- 8-oct-2026 · en pantallas táctiles no hay «pasar el cursor» ----
     Primer toque en la foto: se ve la obra en su espacio. Segundo toque: abre la ficha.
     El título de debajo abre la ficha siempre. */
  if (window.matchMedia && window.matchMedia('(hover: none)').matches) {
    document.querySelectorAll('.pieza').forEach(function(p){
      if (!p.querySelector('.marco .b')) return;
      var a = p.querySelector('a');
      if (!a) return;
      a.addEventListener('click', function(ev){
        if (!ev.target.closest('.marco') || p.classList.contains('ver')) return;
        ev.preventDefault();
        document.querySelectorAll('.pieza.ver').forEach(function(x){ x.classList.remove('ver'); });
        p.classList.add('ver');
      });
    });
  }

  /* ---- 9-oct-2026 · eva-pagina ---- */
  // Alto real de la barra, para que la portada de cada página ocupe la pantalla justa.
  function altoNav(){ if (nav) document.documentElement.style.setProperty('--alto-nav', nav.offsetHeight + 'px'); }
  altoNav(); window.addEventListener('resize', altoNav);

  // Pasos del proceso: en ordenador la foto se queda fija a la izquierda y cambia con cada paso.
  document.querySelectorAll('.ep-pasos').forEach(function(sec){
    var caja = sec.querySelector('.ep-pasos__fotos');
    var pasos = sec.querySelectorAll('.ep-paso');
    if (!caja || !pasos.length || !('IntersectionObserver' in window)) return;
    var imgs = [];
    pasos.forEach(function(p, i){
      var o = p.querySelector('.ep-paso__foto img');
      var c = document.createElement('img');
      if (o) { c.src = o.currentSrc || o.src; c.alt = ''; c.srcset = o.srcset || ''; c.sizes = '45vw'; }
      if (i === 0) c.className = 'on';
      caja.appendChild(c); imgs.push(c);
    });
    sec.classList.add('js');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var i = Array.prototype.indexOf.call(pasos, e.target);
        imgs.forEach(function(im, k){ im.classList.toggle('on', k === i); });
      });
    }, {rootMargin: '-45% 0px -45% 0px'});
    pasos.forEach(function(p){ io.observe(p); });
  });

  // Del boceto a la obra: la obra se descubre una sola vez, al llegar.
  document.querySelectorAll('[data-ep-boceto]').forEach(function(sec){
    if (reduce || !('IntersectionObserver' in window)) return;
    sec.classList.add('listo');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting) { sec.classList.add('visto'); io.disconnect(); } });
    }, {threshold: 0, rootMargin: "0px 0px -30% 0px"});
    io.observe(sec);
  });

  // 9-oct · menú: en pantallas táctiles el primer toque en Portfolio despliega «Toda la obra / Obras en stock»
  var subA = document.querySelector('#nav .sub > a');
  if (subA && window.matchMedia('(hover: none)').matches) {
    subA.addEventListener('click', function(ev){
      var li = subA.parentNode;
      if (!li.classList.contains('abierto')) { ev.preventDefault(); li.classList.add('abierto'); }
    });
    document.addEventListener('click', function(ev){ if (!ev.target.closest('#nav .sub')) subA.parentNode.classList.remove('abierto'); });
  }

  // 9-oct · boceto: movimiento sutil al desplazarse (el papel y la obra a distinta velocidad)
  if (!reduce) {
    document.querySelectorAll('[data-ep-boceto]').forEach(function(sec){
      var papel = sec.querySelector('.ep-boceto__papel'), obra = sec.querySelector('.ep-boceto__obra img');
      tareas.push(function(){
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = Math.max(-1, Math.min(1, (r.top + r.height/2 - vh/2) / vh));
        if (papel) papel.style.setProperty('--py', (p*46).toFixed(1)+'px');
        if (obra) obra.style.transform = 'scale(' + (1.06 - .06*(1-Math.abs(p))).toFixed(4) + ') translateY(' + (p*-14).toFixed(1) + 'px)';
      });
    });
  }

  correr();
})();
